import React, {Fragment} from "react";
import {connect} from "react-redux";
import DropZone from "react-dropzone";


import {setJobPurchaseOrderInvoiceFile} from "../jobPurchaseOrderActions";
import MaterialsIcons from "../../../Icons/MaterialsIcons";

import {
  PURCHASE_ORDER_DOCUMENT_TYPES,
  QUOTE_DOCUMENT_TYPES,
  QUOTE_MAX_DOCUMENT_SIZE
} from "../../../../utilities/constants";
import {formatFileSize, validateFileExtension} from "../../../../utilities";
import {toggle_modal} from "../../../../actions/A_Popups";


const JobPurchaseOrderInvoiceFileUpload = (props) => {

  const {purchaseOrderInvoiceFile, setJobPurchaseOrderInvoiceFile, toggle_modal} = props;

  const showErrorModal = (message) => {
    toggle_modal(true, message, [{text: "Close", color: "blue", onClick: () => toggle_modal(false)}]);
  }

  const handleFileDrop = (acceptedFiles) => {
    console.log("acceptedFiles", acceptedFiles);
    if (!Array.isArray(acceptedFiles) || !acceptedFiles.length) {
      return;
    }
    const file = acceptedFiles[0];
    if (file.size > QUOTE_MAX_DOCUMENT_SIZE) {
      showErrorModal(`File is too large. Max accepted file size is ${formatFileSize(QUOTE_MAX_DOCUMENT_SIZE)}`);
      return;
    }

    if (!validateFileExtension(file.name, QUOTE_DOCUMENT_TYPES)) {
      showErrorModal("*." + file.name.split('.').pop() + ` file type is not accepted.`);
      return;
    }

    setJobPurchaseOrderInvoiceFile(acceptedFiles[0] || null);
  }

  return (
    <DropZone rejectStyle={{'boxShadow': '0 0 1em yellow inset'}}
              accept={PURCHASE_ORDER_DOCUMENT_TYPES}
              onDrop={handleFileDrop}
              disabled={false}
              multiple={false}
              className="height-100 drag-and-drop flex flex--center flex--column text-center
                   job-board-edit-popup__po-upload">
      {purchaseOrderInvoiceFile ? (
        <div className="text-uppercase color-dark2 font--13 bold">
          {purchaseOrderInvoiceFile.name}
        </div>
      ) : (
        <Fragment>
          <div className="w-6 h-6 color-gray2 mb-05">
            {MaterialsIcons.UploadIcon}
          </div>
          <span className="text-uppercase color-charcoal font--13 bold">Drag and Drop Files</span>
          <p className="mt-05 mb-0 color-light pl-1 pr-1 font--14">Supported file formats: PDF, PNG, JPG</p>
        </Fragment>
      )}
    </DropZone>
  )
};

const mapStateToProps = (store) => {
  const {purchaseOrderInvoiceFile} = store.jobPurchaseOrderPopupState;
  const {job} = store.jobEditPopupState;

  return {
    purchaseOrderInvoiceFile,
    job,
  };
};

const mapDispatchToProps = {
  setJobPurchaseOrderInvoiceFile,
  toggle_modal,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPurchaseOrderInvoiceFileUpload)
)
